/*
 * A quiet full-screen layout for flows that need focus: onboarding (/welcome), /activate, long wizards.
 * Logo, an exit link to the overview, language switch; content centred up to 960 px.
 */
import { X } from '@phosphor-icons/react'
import { useTranslation } from 'react-i18next'
import { Link, Outlet } from 'react-router'
import { LanguageSwitch } from './LanguageSwitch'
import { LogoLockup, LogoMark } from './Logo'

export function FocusLayout() {
  const { t } = useTranslation('shell')
  return (
    <div className="relative isolate flex min-h-dvh flex-col bg-app-canvas">
      <div
        aria-hidden="true"
        className="pointer-events-none absolute inset-x-0 top-0 -z-10 h-[28rem] hero-wash [mask-image:linear-gradient(to_bottom,black,transparent)] opacity-70"
      />
      <header className="mx-auto flex h-16 w-full max-w-5xl items-center justify-between gap-3 px-4 sm:px-6">
        <Link to="/overview" aria-label={t('a11y.home')} className="rounded-lg">
          <LogoLockup className="hidden h-[22px] w-auto sm:block" />
          <LogoMark className="h-7 w-auto sm:hidden" />
        </Link>
        <div className="flex items-center gap-1">
          <LanguageSwitch />
          <Link
            to="/overview"
            className="inline-flex h-9 items-center gap-1.5 rounded-xl px-3 text-13 font-semibold text-body transition-colors hover:bg-control hover:text-ink touch:min-h-11"
          >
            <X className="size-4" aria-hidden="true" />
            {t('focus.exit')}
          </Link>
        </div>
      </header>
      <main id="main" className="mx-auto w-full max-w-5xl flex-1 px-4 pt-4 pb-16 sm:px-6 sm:pt-8">
        <Outlet />
      </main>
    </div>
  )
}
